module.exports = __webpack_public_path__ + "static/img/service.9ea8189.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service.jpg
// module id = RxeA
// module chunks = 15